export default {
	title: 'Indikatoren',
	url: 'indikatoren',
	subtitle:
		"Erfassen Sie Ihre Erfolgsindikatoren und ordnen Sie sie Kategorien zu — standardmäßig den 4 Perspektiven der Balanced Scorecard: Finanzen, Kunden, Interne Prozesse, Lernen und Wachstum. Der Tab Visualisierung stellt sie als Balanced Scorecard dar, mit ihrer Entwicklung je Szenario.",
	no_description: 'Kein definierter Indikator',
	context_worse: 'Negativ',
	context_best: 'Positiv',
	tabs: {
		filters: {
			title: 'Ansichtsfilter'
		},
		general: {
			title: 'Allgemein'
		},
		export: {
			title: 'Exportieren'
		},
		comments: {
			title: 'Verlauf'
		},
		bot: {
			title: 'KI'
		}
	},
	messages: {
		edit_constraint: 'Indikator bearbeiten',
		create_constraint: 'Neuen Indikator erstellen'
	},
	onboarding: {
		title: 'Indikatoren-Review',
		description:
			"Prüfen Sie, ob die Indikatoren die Kategorien der Balanced Scorecard abdecken und mit dem Aktionsplan verknüpft sind."
	}
};
